import { createActions } from 'redux-actions';

const TOGGLE_FOCUS_SINK = 'TOGGLE_FOCUS_SINK';

const actionOptions = {
  prefix: 'app/focus',
};

export const actions = createActions(TOGGLE_FOCUS_SINK, actionOptions);
